// extracted by mini-css-extract-plugin
export default {"container":"RedirectBtn_container__TIt0S","box":"RedirectBtn_box__NdDMp","icon":"RedirectBtn_icon__0Spn-"};